import { BackedApi } from "../config/urls/Api";

export interface StoredUser {
    name: string;
    plan: string;
}

const USERS_KEY = "users";
const SESSION_COOKIE_NAMES = ["access_token"];

export class StorageService {
    private static expireCookie(name: string): void {
        const expired = "expires=Thu, 01 Jan 1970 00:00:00 GMT; Max-Age=0";
        const { hostname, pathname } = window.location;
        const paths = Array.from(new Set(["/", pathname]));
        const domains: (string | undefined)[] = [undefined, hostname];

        if (hostname.includes(".")) {
            domains.push(`.${hostname.split(".").slice(-2).join(".")}`);
        }

        for (const path of paths) {
            document.cookie = `${name}=;${expired};path=${path}`;
            document.cookie = `${name}=;${expired};path=${path};SameSite=Lax`;
            document.cookie = `${name}=;${expired};path=${path};SameSite=None;Secure`;

            for (const domain of domains) {
                if (!domain) {
                    continue;
                }

                document.cookie = `${name}=;${expired};path=${path};domain=${domain}`;
                document.cookie = `${name}=;${expired};path=${path};domain=${domain};SameSite=Lax`;
                document.cookie = `${name}=;${expired};path=${path};domain=${domain};SameSite=None;Secure`;
            }
        }
    }

    private static clearCookies(): void {
        const names = new Set<string>(SESSION_COOKIE_NAMES);

        for (const cookie of document.cookie.split(";")) {
            const name = cookie.split("=")[0]?.trim();
            if (name) {
                names.add(name);
            }
        }

        for (const name of names) {
            this.expireCookie(name);
        }
    }

    static async logout(): Promise<void> {
        try {
            await fetch(BackedApi.Logout.url, {
                method: BackedApi.Logout.method,
                credentials: "include",
            });
        } catch {
            // proceed with local cleanup even if the API is unavailable
        }

        window.localStorage.removeItem("signed");
        window.localStorage.removeItem(USERS_KEY);
        this.clearCookies();
    }

    static getUsers(): StoredUser | null {
        try {
            const raw = window.localStorage.getItem(USERS_KEY);
            return raw ? JSON.parse(raw) as StoredUser : null;
        } catch {
            return null;
        }
    }

    static setUsers(user: StoredUser): void {
        const current = this.getUsers();
        if (current?.name === user.name && current?.plan === user.plan) {
            return;
        }

        window.localStorage.setItem(USERS_KEY, JSON.stringify(user));
    }
}
